import React from "react";

const LeadList = React.lazy(() => import("./LeadList"));
const LeadIntake = React.lazy(() => import("./LeadIntake"));
const LeadShow = React.lazy(() => import("./LeadShow"));

export default {
  list: LeadList,
  create: LeadIntake,
  show: LeadShow,
};
